import { useState } from "react";
import { toast } from "sonner";
import { Loader2, BellRing } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger,
} from "@/components/ui/dialog";

export const ReportEmailDialog = () => {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(user?.report_email || "");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.put("/admin/profile", { report_email: email.trim() });
      setUser(res.data);
      toast.success(email.trim() ? "Report notifications will go to " + email.trim() : "Report notifications turned off");
      setOpen(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not save email.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (o) setEmail(user?.report_email || ""); }}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-xl font-heading font-bold" data-testid="report-email-btn">
          <BellRing className="w-4 h-4 mr-1" /> {user?.report_email ? "Report email" : "Set report email"}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading font-extrabold">Report notification email</DialogTitle>
          <DialogDescription className="font-body">
            Whenever one of your candidates completes the assessment, a summary and link to the full report is emailed here.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor="re" className="font-heading font-bold text-slate-800">Email address</Label>
            <Input id="re" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com" className="mt-1.5 rounded-xl" data-testid="report-email-input" />
            <p className="font-body text-xs text-slate-400 mt-2">Leave blank to stop receiving notifications.</p>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="report-email-save-btn"
              className="rounded-xl font-heading font-bold w-full">
              {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null} Save
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
